import React from "react";
import PropTypes from "prop-types";

import AfricaMap from "../map";
import TariffBreakdown from "./TariffBreakdown";
import SeychellesMap from "../map/Seychelles";
import CaboVerdeMap from "../map/CaboVerde";
import MauritiusMap from "../map/Mauritius";

const Highcharts = window.Highcharts;

import { tariffMapColorAxis } from "../map/options";

const getTariffValueColor = value => {
  const colorAxisObj = tariffMapColorAxis.find(color => color.from < value && color.to > value);
  return colorAxisObj.color;
};

const Tariffs = ({
  mapOptions,
  selectedCountry,
  data,
  currentYear,
  selectCountry,
  seychellesTariffValue,
  caboVerdeTariffValue,
  mauritiusTariffValue,
  currentTab
}) => (
  <div>
    <section className="tariff-breakdown">
      <div className="map-wrapper">
        <div className="map-help" />
          <AfricaMap
            options={mapOptions}
            highcharts={Highcharts}
            selectedCountry={selectedCountry}
            currentTab={currentTab}
          />
          <div className="island-maps">
            <SeychellesMap
              highcharts={Highcharts}
              selectedCountry={selectedCountry}
              selectCountry={selectCountry}
              options={mapOptions}
              tariffValueColor={getTariffValueColor(seychellesTariffValue)}
            />
            <CaboVerdeMap
              highcharts={Highcharts}
              selectedCountry={selectedCountry}
              selectCountry={selectCountry}
              options={mapOptions}
              tariffValueColor={getTariffValueColor(caboVerdeTariffValue)}
            />
            <MauritiusMap
              highcharts={Highcharts}
              selectedCountry={selectedCountry}
              selectCountry={selectCountry}
              options={mapOptions}
              tariffValueColor={getTariffValueColor(mauritiusTariffValue)}
            />
          </div>
      </div>
      <div className="chart-wrapper">
        {selectedCountry !== "all" && <TariffBreakdown data={data} currentYear={currentYear} />}
      </div>
    </section>
  </div>
);

export default Tariffs;

Tariffs.propTypes = {
  currentTab: PropTypes.string.isRequired,
  currentYear: PropTypes.number.isRequired,
  seychellesTariffValue: PropTypes.number.isRequired,
  caboVerdeTariffValue: PropTypes.number.isRequired,
  mauritiusTariffValue: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mapOptions: PropTypes.shape({}).isRequired,
  selectedCountry: PropTypes.string.isRequired,
  selectCountry: PropTypes.func.isRequired,
};
